module.exports = __webpack_public_path__ + "static/media/1-point.f212213f.png";